
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1xupv_1fymf_94",
  "wizard": "awsui_wizard_1xupv_1fymf_129",
  "refresh": "awsui_refresh_1xupv_1fymf_129",
  "small-container": "awsui_small-container_1xupv_1fymf_136",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_1xupv_1fymf_140",
  "navigation": "awsui_navigation_1xupv_1fymf_148",
  "number": "awsui_number_1xupv_1fymf_212",
  "circle": "awsui_circle_1xupv_1fymf_228",
  "title": "awsui_title_1xupv_1fymf_236",
  "active": "awsui_active_1xupv_1fymf_264",
  "disabled": "awsui_disabled_1xupv_1fymf_275",
  "enabled": "awsui_enabled_1xupv_1fymf_285",
  "form": "awsui_form_1xupv_1fymf_326",
  "form-header": "awsui_form-header_1xupv_1fymf_331",
  "background": "awsui_background_1xupv_1fymf_341",
  "form-header-content": "awsui_form-header-content_1xupv_1fymf_353",
  "form-component": "awsui_form-component_1xupv_1fymf_361",
  "hidden": "awsui_hidden_1xupv_1fymf_375",
  "collapsed-steps": "awsui_collapsed-steps_1xupv_1fymf_379",
  "collapsed-steps-hidden": "awsui_collapsed-steps-hidden_1xupv_1fymf_384",
  "form-header-component-wrapper": "awsui_form-header-component-wrapper_1xupv_1fymf_388",
  "form-header-component": "awsui_form-header-component_1xupv_1fymf_388",
  "navigation-link": "awsui_navigation-link_1xupv_1fymf_401",
  "navigation-link-item": "awsui_navigation-link-item_1xupv_1fymf_402",
  "navigation-link-label": "awsui_navigation-link-label_1xupv_1fymf_403",
  "navigation-link-active": "awsui_navigation-link-active_1xupv_1fymf_407",
  "navigation-link-disabled": "awsui_navigation-link-disabled_1xupv_1fymf_412",
  "cancel-button": "awsui_cancel-button_1xupv_1fymf_416",
  "previous-button": "awsui_previous-button_1xupv_1fymf_417",
  "primary-button": "awsui_primary-button_1xupv_1fymf_418",
  "skip-to-button": "awsui_skip-to-button_1xupv_1fymf_419",
  "action-buttons": "awsui_action-buttons_1xupv_1fymf_423"
};
  